var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 4.33333H2.66668C1.9303 4.33333 1.33334 4.93029 1.33334 5.66667V11.6667C1.33334 12.403 1.9303 13 2.66668 13H4.00001C4.73639 13 5.33334 12.403 5.33334 11.6667V5.66667C5.33334 4.93029 4.73639 4.33333 4.00001 4.33333Z",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5846 13H8.14075C7.61428 13 7.09959 12.8442 6.66154 12.5521L5.63021 11.8646C5.44474 11.7409 5.33334 11.5328 5.33334 11.3099V5.84371C5.33334 5.72769 5.36362 5.61368 5.42118 5.51295L8.00001 1H8.88582C10.217 1 11.011 2.48357 10.2726 3.59117L9.33334 5H12.959C13.8264 5 14.4629 5.81518 14.2525 6.65671L13.1717 10.9801C12.8749 12.1672 11.8083 13 10.5846 13Z",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/thumbsup.ac0c3dfd192fe392fe04f2386b692e26.svg";
export { ForwardRef as ReactComponent };